import {
  PAYMENT_REQUEST_LIST,
  PAYMENT_REQUEST_LIST_SUCCESS,
  PAYMENT_REQUEST_LIST_FAIL,
  PAYMENT_REQUEST_PREVIEW,
  PAYMENT_REQUEST_PREVIEW_SUCCESS,
  PAYMENT_REQUEST_PREVIEW_FAIL,
  PAYMENT_REQUEST_PREDICTED,
  PAYMENT_REQUEST_PREDICTED_SUCCESS,
  PAYMENT_REQUEST_PREDICTED_FAIL,
  PAYMENT_REQUEST_UNCOLLECTABLE,
  PAYMENT_REQUEST_UNCOLLECTABLE_SUCCESS,
  PAYMENT_REQUEST_UNCOLLECTABLE_FAIL,
  PAYMENT_REQUEST_DATA,
  PAYMENT_REQUEST_DATA_SUCCESS,
  PAYMENT_REQUEST_DATA_FAIL,
  PAYMENT_REQUEST_CREATE,
  PAYMENT_REQUEST_CREATE_SUCCESS,
  PAYMENT_REQUEST_CREATE_FAIL,
  PAYMENT_REQUEST_SEARCH,
  PAYMENT_REQUEST_SEARCH_SUCCESS,
  PAYMENT_REQUEST_SEARCH_FAIL,
  PAYMENT_REQUEST_VOID,
  PAYMENT_REQUEST_VOID_SUCCESS,
  PAYMENT_REQUEST_VOID_FAIL,
} from "./actionType";

//PAYMENT_REQUEST_LIST
export const paymentRequestList = (params) => {
  return {
    type: PAYMENT_REQUEST_LIST,
    payload: params,
  };
};
export const paymentRequestListSuccess = (data) => {
  return {
    type: PAYMENT_REQUEST_LIST_SUCCESS,
    payload: data,
  };
};
export const paymentRequestListFail = (error) => {
  return {
    type: PAYMENT_REQUEST_LIST_FAIL,
    payload: error,
  };
};
//PAYMENT_REQUEST_PREVIEW
export const paymentRequestPreview = (params) => {
  return {
    type: PAYMENT_REQUEST_PREVIEW,
    payload: params,
  };
};
export const paymentRequestPreviewSuccess = (data) => {
  return {
    type: PAYMENT_REQUEST_PREVIEW_SUCCESS,
    payload: data,
  };
};
export const paymentRequestPreviewFail = (error) => {
  return {
    type: PAYMENT_REQUEST_PREVIEW_FAIL,
    payload: error,
  };
};
//PAYMENT_REQUEST_PREDICTED
export const paymentRequestPredicted = (params) => {
  return {
    type: PAYMENT_REQUEST_PREDICTED,
    payload: params,
  };
};
export const paymentRequestPredictedSuccess = (data) => {
  return {
    type: PAYMENT_REQUEST_PREDICTED_SUCCESS,
    payload: data,
  };
};
export const paymentRequestPredictedFail = (error) => {
  return {
    type: PAYMENT_REQUEST_PREDICTED_FAIL,
    payload: error,
  };
};
//PAYMENT_REQUEST_UNCOLLECTABLE
export const paymentRequestUncollectable = (params) => {
  return {
    type: PAYMENT_REQUEST_UNCOLLECTABLE,
    payload: params,
  };
};
export const paymentRequestUncollectableSuccess = (data) => {
  return {
    type: PAYMENT_REQUEST_UNCOLLECTABLE_SUCCESS,
    payload: data,
  };
};
export const paymentRequestUncollectableFail = (error) => {
  return {
    type: PAYMENT_REQUEST_UNCOLLECTABLE_FAIL,
    payload: error,
  };
};
//PAYMENT_REQUEST_DATA
export const paymentRequestData = (params) => {
  return {
    type: PAYMENT_REQUEST_DATA,
    payload: params,
  };
};
export const paymentRequestDataSuccess = (data) => {
  return {
    type: PAYMENT_REQUEST_DATA_SUCCESS,
    payload: data,
  };
};
export const paymentRequestDataFail = (error) => {
  return {
    type: PAYMENT_REQUEST_DATA_FAIL,
    payload: error,
  };
};
//PAYMENT_REQUEST_CREATE
export const paymentRequestCreate = (params) => {
  return {
    type: PAYMENT_REQUEST_CREATE,
    payload: params,
  };
};
export const paymentRequestCreateSuccess = (data) => {
  return {
    type: PAYMENT_REQUEST_CREATE_SUCCESS,
    payload: data,
  };
};
export const paymentRequestCreateFail = (error) => {
  return {
    type: PAYMENT_REQUEST_CREATE_FAIL,
    payload: error,
  };
};
//PAYMENT_REQUEST_SEARCH
export const paymentRequestSearch = (params) => {
  return {
    type: PAYMENT_REQUEST_SEARCH,
    payload: params,
  };
};
export const paymentRequestSearchSuccess = (data) => {
  return {
    type: PAYMENT_REQUEST_SEARCH_SUCCESS,
    payload: data,
  };
};
export const paymentRequestSearchFail = (error) => {
  return {
    type: PAYMENT_REQUEST_SEARCH_FAIL,
    payload: error,
  };
};
//PAYMENT_REQUEST_VOID
export const paymentRequestVoid = (params) => {
  return {
    type: PAYMENT_REQUEST_VOID,
    payload: params,
  };
};
export const paymentRequestVoidSuccess = (data) => {
  return {
    type: PAYMENT_REQUEST_VOID_SUCCESS,
    payload: data,
  };
};
export const paymentRequestVoidFail = (error) => {
  return {
    type: PAYMENT_REQUEST_VOID_FAIL,
    payload: error,
  };
};
